/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const EntryType = {
    User: 'User',
    Class: 'Class',
    Teacher: 'Teacher',
    Student: 'Student',
    Team: 'Team',
    Event: 'Event',
    Location: 'Location',
    Tenant: 'Tenant',
    ClassRoom: 'ClassRoom',
    Report: 'Report',
    Season: 'Season',
    Dance: 'Dance'
} as const;
export type EntryType = typeof EntryType[keyof typeof EntryType];


export function instanceOfEntryType(value: any): boolean {
    for (const key in EntryType) {
        if (Object.prototype.hasOwnProperty.call(EntryType, key)) {
            if (EntryType[key as keyof typeof EntryType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function EntryTypeFromJSON(json: any): EntryType {
    return EntryTypeFromJSONTyped(json, false);
}

export function EntryTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): EntryType {
    return json as EntryType;
}

export function EntryTypeToJSON(value?: EntryType | null): any {
    return value as any;
}

export function EntryTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): EntryType {
    return value as EntryType;
}

